<template>
    <CustomAutocomplete :completeFunction="searchCoveringCertificate" :emptyValue="false" :dropdown="dropdown" v-model="internalValue"
                        :name="name" :label="label" :width="width" :customErrorMessage="customErrorMessage"
                        :itemFromQuery="false" :disabled="disabled" :required="required" :field="searchParam"
                        :showErrors="showErrors" completeOnFocus itemValue="id"/>
</template>

<script>
import {getAvailableCoveringCertificatesByQuery} from "@/swagger/vue-api-client";
    import CustomAutocomplete from "./inner/CustomAutocomplete";

    export default {
        name: "CustomAutocompleteCoveringCertificate",
        props: {
            name: {
                type: String,
            },
            label: {
                type: String,
            },
            emptyValue: {
                type: Boolean,
                default: true,
            },
            modelValue: null,
            searchParam: {
                type: String,
                default: "name",
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            customErrorMessage: {
                type: String,
                default: "",
            },
            showErrors: {
                type: Boolean,
                default: false,
            },
            required: {
                type: Boolean,
                default: false,
            },
            dropdown: {
                type: Boolean,
                default: false,
            },
            width: {
                type: String,
                default: null,
            },
        },

        emits: ["update:modelValue"],

        computed: {
            internalValue: {
                get() { return this.modelValue; },
                set(value) { this.$emit("update:modelValue", value); },
            },
        },

        data() {
            return {
                items: [],
                selectedValue: null,
                searchCoveringCertificate: async (obj) => {
                    const { query } = obj;
                    return getAvailableCoveringCertificatesByQuery({query: query});
                },
            };
        },

        components: {CustomAutocomplete},
    };
</script>

<style scoped>

</style>
